/**
 * Whether the current user may see transport pricing.
 *
 * Read directly by the leaf components that render prices rather than threaded
 * as a prop: MapStatsOverlay and TimeLine are mounted from both the show page
 * (ShowRouteContainer) and the planning page (RouteMap / RouteEdit), and the
 * planning path passes neither isAdmin nor any permission prop — a fail-closed
 * prop would silently blank the prices for admins while planning.
 *
 * Fail-closed: the flag is published by both RoutesController@show and
 * App\Managers\Routes::getRoutesData().
 */
export const canViewTransportPrices = () =>
  Boolean(window.routeData?.can_view_transport_prices);
